/*
 * Houses the model used to update multiple topic statuses at once
 */

define(["backbone", "configuration/properties", "messaging/messenger"], function (
  Backbone,
  Properties,
  Messenger,
) {
  let TopicsControlsModel = {};

  TopicsControlsModel.multiTopicContextModel = Backbone.Model.extend({
    idAttribute: "contextId",
    url: function () {
      const kbId = Messenger.reqres.request("active:kb");
      return Properties.rootURL + "/" + kbId + "/intents/contexts";
    },
  });

  TopicsControlsModel.multiTopicStatusModel = Backbone.Model.extend({
    idAttribute: "statusId",
    url: function () {
      const kbId = Messenger.reqres.request("active:kb");
      return Properties.rootURL + "/" + kbId + "/intents/statuses";
    },
  });

  TopicsControlsModel.topicsArchiveModel = Backbone.Model.extend({
    defaults: {
      intents: [],
    },
    url: function () {
      const kbId = Messenger.reqres.request("active:kb");
      return Properties.rootURL + "/" + kbId + "/intents/archive";
    },
  });

  TopicsControlsModel.topicsRestoreModel = Backbone.Model.extend({
    defaults: {
      intents: [],
    },
    url: function () {
      const kbId = Messenger.reqres.request("active:kb");
      return Properties.rootURL + "/" + kbId + "/intents/restore";
    },
  });

  return TopicsControlsModel;
});
